module.exports = __webpack_public_path__ + "static/media/teachers-05.4e51c001.png";